export class SectorEconomico {
    idSector: number = 0;
    Nombre_Sector: string = '';
    Codigo_Sector: string = '';
    Estado: string = '';
    Estado_Descripcion: string = '';
    Alta_Fecha: Date = new Date();
    Alta_Canal: string = '';
    Alta_Usuario: string = '';
    Modificacion_Fecha: Date = new Date();
    Modificacion_Canal: string = '';
    Modificacion_Usuario: string = ''; 
}